// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Media__list-d47dd8 {
  display: grid;
  grid-template-columns: repeat(var(--sharedmedia-column-count), 1fr);
  grid-gap: 2px;
  padding: 0 2px;
  margin: 8px 0 24px 0;
}

.Media__item-cc8938 {
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/main/SharedData/Media/Media.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mEAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACF","sourcesContent":[".list {\n  display: grid;\n  grid-template-columns: repeat(var(--sharedmedia-column-count), 1fr);\n  grid-gap: 2px;\n  padding: 0 2px;\n  margin: 8px 0 24px 0;\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `Media__list-d47dd8`,
	"item": `Media__item-cc8938`
};
module.exports = ___CSS_LOADER_EXPORT___;
